import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PropertyManagement = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row className="section">
        <Col md={12} className="d-flex flex-column justify-content-center">
          <h2>{t("propertymgmt_main_title")}</h2>
          <p>{t("propertymgmt_main_p")}</p>
        </Col>
        <Col>
          <Row className="mb-20-desktop">
            <Col md={6}>
              <img src="/images/card.jpg"  className="fullimgcover" />
            </Col>
            <Col md={6}>
              <img src="/images/app.jpg"  className="fullimgcover" />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <img src="/images/water.jpg"  className="fullimgcover" />
            </Col>
            <Col md={6}>
              <img src="/images/O7.jpg"  className="fullimgcover" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default PropertyManagement;
